<div class="template-wrap">
  <!--<span class="checked-icon-wrap" *ngIf="selectedTemplate === template.template_id"><i class="db-icon db-icon-ds-checkmark"></i></span>-->
  <div
          id="db-create-ai-assistant-template-select__template_{{template?.template_id}}"
          class="db-create-ai-assistant-template-select__template"
          [ngClass]="{'selected': selectedTemplate === template?.template_id, 'ds-lazy-load': !!imagesLoading}">
    <img src="assets/images/templates/{{template?.template_id}}-{{theme}}{{newScreenShots ? '-new' : ''}}.jpeg" alt="">
  </div>
</div>
